import { jsx, jsxs } from "react/jsx-runtime";
import { Attribute, Card, Heading, Image, Price, ReviewScore, Span } from "@pcln/horizon";
function formatNumericCount(reviewCount) {
    const numeric = Number(reviewCount.replace(/\D/g, ''));
    if (!Number.isFinite(numeric)) return reviewCount;
    return numeric.toLocaleString('en-US');
}
function HotelProductSummaryView({ url, onClick, imageSrc, summaryHeader, summaryBody, reviewScore, roomInfo }) {
    const { rating, reviewCount, stars } = reviewScore;
    const { numRooms = 1, numNights = 2, price, currencySymbol } = roomInfo || {};
    return /*#__PURE__*/ jsx(Card, {
        cardClassName: "overflow-hidden p-0",
        onClick: ()=>{
            window.open(url, '_blank', 'noopener,noreferrer');
            if (onClick) onClick();
        },
        children: /*#__PURE__*/ jsxs("div", {
            className: "flex items-start self-stretch",
            children: [
                /*#__PURE__*/ jsx(Image, {
                    src: imageSrc,
                    alt: summaryHeader,
                    width: 18,
                    className: "self-stretch"
                }),
                /*#__PURE__*/ jsxs("div", {
                    className: "flex min-w-0 flex-1 items-center justify-between gap-2 p-2",
                    children: [
                        /*#__PURE__*/ jsxs("div", {
                            className: "flex max-w-80 min-w-0 flex-1 flex-col items-start gap-2",
                            children: [
                                /*#__PURE__*/ jsx(Heading, {
                                    as: "h6",
                                    align: "left",
                                    lineClamp: 1,
                                    children: summaryHeader
                                }),
                                /*#__PURE__*/ jsx(Attribute, {
                                    size: "sm",
                                    iconName: "location_on",
                                    text: summaryBody,
                                    truncate: true,
                                    className: "w-full"
                                }),
                                rating && reviewCount && stars && /*#__PURE__*/ jsx(ReviewScore, {
                                    size: "xs",
                                    rating: rating,
                                    reviewCount: `(${formatNumericCount(reviewCount)})`,
                                    data: `${stars}-Star Hotel`
                                })
                            ]
                        }),
                        roomInfo && price && /*#__PURE__*/ jsxs("div", {
                            className: "flex shrink-0 flex-col items-end",
                            children: [
                                /*#__PURE__*/ jsx(Price, {
                                    price: formatNumericCount(price),
                                    currencySymbol: currencySymbol || '$',
                                    type: "neutral",
                                    textStyle: "heading4",
                                    isFormatted: true
                                }),
                                /*#__PURE__*/ jsx(Span, {
                                    textStyle: "body3",
                                    palette: "primary",
                                    shade: "10",
                                    children: `${numNights} night${numNights > 1 ? 's' : ''}`
                                }),
                                /*#__PURE__*/ jsx(Span, {
                                    textStyle: "body3",
                                    palette: "primary",
                                    shade: "10",
                                    children: `${numRooms} room${numRooms > 1 ? 's' : ''}`
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
export { HotelProductSummaryView };
